$(function () {
  'use strict';

  if ($('.training-body-screen').length > 0) {
    const dir = $('html').attr('dir');

    $.validator.addMethod("emailPattern", function (value, element) { // new method for email validation
      return this.optional(element) || /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(value);
    });
    $.validator.addMethod("numberPattern", function (value, element) {
      return this.optional(element) || /^[\d\u0660-\u0669\u06F0-\u06F9]{8}$/.test(value);
    });
    $.validator.addMethod("exNumbers", function (value, element) {
      return this.optional(element) || /^[\d\u0660-\u0669\u06F0-\u06F9]{1,2}$/.test(value);
    });
    $.validator.addMethod("nameChar", function (value, element) {
      return this.optional(element) || /^[a-zA-Z\u0600-\u06FF&() -]+$/.test(value);
    });
    $.validator.addMethod("idnumberPattern", function (value, element) {
      return this.optional(element) || /^[0-9]+$/.test(value);
    });

    const messagesError = {
      name: {
        en: 'Please provide your name',
        ar: 'رجاء كتابة اسمك'
      },
      number: {
        required: {
          en: 'Please provide your number without country code',
          ar: "يرجى تقديم رقمك بدون رمز البلد"
        },
        numberPattern: {
          en: 'Please enter a valid number',
          ar: "رجاء إدخال رقم هاتف صحيح"
        }
      },
      id_number: {
        required: {
          en: 'Please provide your ID number',
          ar: "رجاء إدخال رقم الهوية الخاصة بك"
        },
        numberPattern: {
          en: 'Please enter a valid ID number',
          ar: 'رجاء ادخال رقم هوية صحيح'
        }
      },
      email: {
        en: 'Please enter a valid email address',
        ar: 'رجاء إدخال عنوان بريد إلكتروني صالح'
      },
      school: {
        en: 'Please provide school name',
        ar: "يرجى تقديم اسم المدرسة"
      },
      university: {
        en: 'Please provide University name',
        ar: "يرجى تقديم اسم الجامعة"
      },
      major: {
        en: 'Please provide the major',
        ar: 'يرجى تقديم التخصص'
      },
      hours: {
        en: 'Please provide the required hours',
        ar: 'يرجى تقديم الساعات المطلوبة'
      },
      res_name: {
        en: 'Please provide the name of the administrator',
        ar: "يرجى تقديم اسم المسؤول"
      },
      office_no: {
        required: {
          en: 'Please provide number without country code',
          ar: "يرجى تقديم الرقم بدون رمز البلد"
        },
        numberPattern: {
          en: 'Please enter a valid number',
          ar: "رجاء إدخال رقم هاتف صحيح"
        }
      },
      id_pic: {
        en: 'Please upload your ID',
        ar: "يرجى تحميل صورة الهوية"
      },
      cv: {
        en: 'Please upload your CV',
        ar: "يرجى تحميل سيرتك الذاتية"
      },
      uni_letter: {
        en: 'Please upload your University Letter',
        ar: "يرجى تحميل خطاب الجامعة"
      },
      stu_table: {
        en: 'Please upload your student time table',
        ar: "يرجى تحميل الجدول الزمني للطالب الخاص بك"
      },
    }

    $('#trainingForm').validate({
      rules: {
        name: {
          // required: true,
          nameChar: true
        },
        "personal-id-nmber": {
          // required: true,
          idnumberPattern: true
        },
        // school: "required",
        // university: "required",
        // 'primary-specialization': 'required',
        // 'hours-of-training': 'required',
        'telephone-number': {
          // required: true,
          numberPattern: true
        },
        email: {
          // required: true,
          emailPattern: true
        },
        // 'responsible-name': 'required',
        'office-no': {
          // required: true,
          numberPattern: true
        },
        emailfield: {
          // required: true,
          emailPattern: true
        },
        // 'attachment-1': 'required',
        // 'attachment-2': 'required',
        // 'attachment-3': 'required',
        // 'attach-student-time-table': 'required',
      },
      messages: {
        name: {
          required: dir == 'ltr'? messagesError.name.en : messagesError.name.ar,
          nameChar: dir == 'ltr'? messagesError.name.en : messagesError.name.ar
        },
        "personal-id-nmber": {
          required: dir == 'ltr'? messagesError.id_number.required.en : messagesError.id_number.required.ar,
          idnumberPattern: dir == 'ltr'? messagesError.id_number.numberPattern.en : messagesError.id_number.numberPattern.ar
        },
        school: dir == 'ltr'? messagesError.school.en : messagesError.school.ar,
        university: dir == 'ltr'? messagesError.university.en : messagesError.uni_letter.ar,
        'primary-specialization': dir == 'ltr'? messagesError.major.en : messagesError.major.ar,
        'hours-of-training': dir == 'ltr'? messagesError.hours.en : messagesError.hours.ar,
        'telephone-number': {
          required: dir == 'ltr'? messagesError.number.required.en : messagesError.number.required.ar,
          numberPattern: dir == 'ltr'? messagesError.number.numberPattern.en : messagesError.number.numberPattern.ar
        },
        email: {
          required: dir == 'ltr'? messagesError.email.en : messagesError.email.ar,
          emailPattern: dir == 'ltr'? messagesError.email.en : messagesError.email.ar,
        },
        'responsible-name': dir == 'ltr'? messagesError.res_name.en : messagesError.res_name.ar,
        'office-no': {
          required: dir == 'ltr'? messagesError.office_no.required.en : messagesError.office_no.required.ar,
          numberPattern: dir == 'ltr'? messagesError.office_no.numberPattern.en : messagesError.office_no.numberPattern.ar
        },
        emailfield: {
          required: dir == 'ltr'? messagesError.email.en : messagesError.email.ar,
          emailPattern: dir == 'ltr'? messagesError.email.en : messagesError.email.ar,
        },
        'attachment-1': dir == 'ltr'? messagesError.id_pic.en : messagesError.id_pic.ar,
        'attachment-2': dir == 'ltr'? messagesError.cv.en : messagesError.cv.ar,
        'attachment-3': dir == 'ltr'? messagesError.uni_letter.en : messagesError.uni_letter.ar,
        'attach-student-time-table': dir == 'ltr'? messagesError.stu_table.en : messagesError.stu_table.ar,
      },
      errorElement: 'em',
    })
  }

})